// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"81280c7f","184":"9aef3322","632":"3ee9792f","716":"81280c7f","896":"81280c7f","916":"ca748fa4"}[chunkId] + ".chunk.css";
};